import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

import { Headline } from 'components/Headline';

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  text-align: left;

  padding: 1.5rem;
  margin-bottom: 2rem;

  border: 0.1rem solid ${pickColor('dangerRedLight')};
  border-radius: ${({ theme }) => theme.borderRadius.base};

  background-color: ${pickColor('abandonedBackground')};
`;

const Info = styled(Headline)`
  margin-left: 1.5rem;
  text-wrap: auto;
`;

export { Container, Info };
